var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { dia, util, linkTools, shapes } from '@joint/plus';
import { VisioArchive, types } from '@joint/format-visio';
var VisioSectionType = types.VisioSectionType;
var standard = shapes.standard, bpmn2 = shapes.bpmn2;
export var init = function () { return __awaiter(void 0, void 0, void 0, function () {
    var graph, paper, vsdDocument, page, pageContent, poolLabel, cells, elements, lanesMap, headerSize, poolBBox, poolLanes, pool;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                graph = new dia.Graph();
                paper = new dia.Paper({
                    el: document.getElementById('paper'),
                    model: graph,
                    width: 1000,
                    height: 600,
                    gridSize: 10,
                    interactive: true,
                    async: true,
                    frozen: true,
                    background: { color: '#F3F7F6' },
                    defaultConnectionPoint: { name: 'boundary', args: { stroke: true } }
                });
                return [4 /*yield*/, VisioArchive.fromURL('./assets/process.vsdx')];
            case 1:
                vsdDocument = (_a.sent()).document;
                page = vsdDocument.getPages()[0];
                return [4 /*yield*/, page.getContent()];
            case 2:
                pageContent = _a.sent();
                poolLabel = '';
                cells = pageContent.toGraphCells({
                    importShape: function (vsdShape) {
                        var master = vsdShape.getMaster();
                        if (!master)
                            return null;
                        var element;
                        switch (master.name) {
                            case 'CFF Container': {
                                var _a = vsdShape.getSubShapes(), vsdLabelShape = _a[1];
                                poolLabel = vsdLabelShape.getText();
                                return null;
                            }
                            case 'Process': {
                                element = new standard.Rectangle({
                                    attrs: {
                                        body: {
                                            fill: '#3276CE'
                                        },
                                        label: {
                                            fill: '#FFFFFF',
                                            fontFamily: 'sans-serif',
                                            textWrap: {
                                                width: -10,
                                                height: -10
                                            }
                                        }
                                    }
                                });
                                break;
                            }
                            case 'Decision': {
                                element = new standard.Polygon({
                                    attrs: {
                                        body: {
                                            refPoints: '10 0 20 10 10 20 0 10',
                                            fill: '#3E549E'
                                        },
                                        label: {
                                            fill: '#FFFFFF',
                                            fontFamily: 'sans-serif',
                                            textWrap: {
                                                width: -30,
                                                height: -10
                                            }
                                        }
                                    }
                                });
                                break;
                            }
                            default: {
                                return null;
                            }
                        }
                        var data = vsdShape.getComputedSection(VisioSectionType.Property);
                        var lane = data.getProperty('Function');
                        var text = vsdShape.getText();
                        var _b = vsdShape.getPageBBox(), x = _b.x, y = _b.y, width = _b.width, height = _b.height;
                        element.prop({
                            position: { x: x, y: y },
                            size: { width: width, height: height },
                            z: vsdShape.getPageZIndex(),
                            lane: lane,
                            attrs: {
                                label: {
                                    text: text
                                }
                            }
                        });
                        return element;
                    },
                    importConnect: function (vsdConnect, sourceElement, targetElement) {
                        if (!sourceElement)
                            return null;
                        var _a = vsdConnect.toLinkAttributes(sourceElement, targetElement), vertices = _a.vertices, z = _a.z;
                        var link = new standard.Link({
                            vertices: vertices,
                            z: z,
                            source: { id: sourceElement.id },
                            target: { id: targetElement.id }
                        });
                        return link;
                    },
                    importLabels: function (vsdShape, link) {
                        var text = vsdShape.getText();
                        if (text) {
                            link.appendLabel({
                                attrs: {
                                    text: {
                                        text: text,
                                        fontFamily: 'sans-serif'
                                    }
                                }
                            });
                        }
                    }
                });
                graph.resetCells(cells);
                elements = cells.filter(function (cell) { return cell.isElement(); });
                lanesMap = new Map();
                util.sortBy(elements, [function (el) { return el.attributes.position.y; }]).forEach(function (el) {
                    var laneName = el.get('lane');
                    var record = lanesMap.get(laneName);
                    if (!record) {
                        record = { els: [], label: laneName };
                        lanesMap.set(laneName, record);
                    }
                    record.els.push(el);
                });
                lanesMap.forEach(function (record) {
                    var _a = graph.getCellsBBox(record.els), y = _a.y, height = _a.height;
                    record.y1 = y;
                    record.y2 = y + height;
                });
                headerSize = 30;
                poolBBox = graph.getBBox().inflate(headerSize + 30, 50);
                poolLanes = Array.from(lanesMap.values()).map(function (record, index, lanes) {
                    var poolLane = { label: record.label };
                    var nextRecord = lanes[index + 1];
                    if (nextRecord) {
                        var y1 = record.y2;
                        var y2 = nextRecord.y1;
                        var y0 = (y1 + y2) / 2;
                        nextRecord.y = y0;
                        poolLane.size = y0 - ((index > 0) ? record.y : poolBBox.y);
                    }
                    return poolLane;
                });
                pool = new bpmn2.HeaderedPool({
                    z: -1,
                    position: {
                        x: poolBBox.x,
                        y: poolBBox.y
                    },
                    size: {
                        width: poolBBox.width,
                        height: poolBBox.height
                    },
                    lanes: poolLanes,
                    attrs: {
                        header: {
                            fill: '#E1DFDD',
                            stroke: '#333333'
                        },
                        headerLabel: {
                            text: poolLabel
                        },
                        laneHeaders: {
                            fill: '#F3F2F1'
                        },
                        laneLabels: {
                            fontWeight: 'bold',
                            fill: '#333333'
                        }
                    }
                });
                graph.addCell(pool);
                cells.forEach(function (cell) { return pool.embed(cell); });
                paper.fitToContent({ useModelGeometry: true, padding: 10, allowNewOrigin: 'any' });
                paper.unfreeze();
                paper.on({
                    'link:mouseenter': function (linkView) {
                        var toolsView = new dia.ToolsView({
                            tools: [
                                new linkTools.Vertices(),
                                new linkTools.Segments()
                            ]
                        });
                        linkView.addTools(toolsView);
                    },
                    'link:mouseleave': function (linkView) {
                        linkView.removeTools();
                    }
                });
                return [2 /*return*/];
        }
    });
}); };
